import i18n from "@/i18n";
import * as shared from "@/styles/shared";
import type { ErrorBoundaryProps, ErrorBoundaryState } from "@/types/auth";
import { Component } from "react";
import * as styles from "./ErrorBoundary.styles";

const ErrorFallback = () => {
  const t = (key: string, defaults?: Record<string, unknown>) => i18n.t(key, { ...defaults, defaultValue: key });

  return (
    <div className={shared.centerScreen}>
      <div className={styles.card}>
        <h2 className={styles.errorTitle}>{t("message.somethingWentWrong")}</h2>
        <p className={styles.errorDescription}>{t("message.unexpectedError")}</p>
        <button
          onClick={() => {
            window.location.reload();
          }}
          className={styles.reloadBtn}
        >
          {t("message.reloadPage")}
        </button>
      </div>
    </div>
  );
};

export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || <ErrorFallback />;
    }
    return this.props.children;
  }
}
